const COLUMN_PREFIX = "grow.lead_generator.exist.table";

/**
 * Type-safe translation key generators for columns translations
 */
export const columnKeys = {
    /**
     * Generate key for column title
     */
    title: (field: string) => `${COLUMN_PREFIX}.column.${field}`,

    /**
     * Generate key for column tooltip
     */
    tooltip: (field: string, modifier?: string) => `${COLUMN_PREFIX}.tooltip.${modifier ? `${modifier}.` : ""}${field}`,
} as const;
